<!--@formatter:off-->
<i18n src="./locale.json"></i18n>
<!--@formatter:on-->

<template lang="pug">

  form(v-on:submit.prevent="handleSubmit")

    c-form-error(v-bind:message="$t(responseErrorMessage)")

    c-input-phone(v-bind:code.sync="phoneCode" v-bind:number.sync="phoneNumber")

    c-form-submit(v-bind:isDisabled="isInvalidRequestParams()" v-bind:isLoading="requestBeingProcessed") {{ $t('btn_submit') }}

</template>

<script>
import { minLength, numeric, required } from 'vuelidate/lib/validators';

import * as responseCodes from 'classes/response-codes';
import cFormError from 'components/c-form/c-form-error/component';
import cInputPhone from 'components/c-form/c-form-input-phone/component';
import cFormSubmit from 'components/c-form/c-form-submit/component';
import mFormSubmit from 'mixins/formSubmit';
import * as types from 'store/mutation-types';

export default {
  mixins: [mFormSubmit],

  components: {
    cInputPhone,
    cFormError,
    cFormSubmit,
  },

  data() {
    return {};
  },

  validations() {
    return {
      phoneCode: {
        required,
        numeric,
        minLength: minLength(1),
      },
      phoneNumber: {
        required,
        numeric,
        minLength: minLength(10),
      },
    };
  },

  computed: {
    phoneCode: {
      get() {
        return this.$store.state.registration.phoneCode;
      },
      set(val) {
        this.$store.commit(`registration/${types.SET_PHONE_CODE}`, val.replace(/\D/g, ''));
      },
    },
    phoneNumber: {
      get() {
        return this.$store.state.registration.phoneNumber;
      },
      set(val) {
        this.$store.commit(`registration/${types.SET_PHONE_NUMBER}`, val.replace(/\D/g, ''));
      },
    },
  },

  methods: {
    handleRequestUrl() {
      return '/password/send-security-code';
    },

    handleRequestParams() {
      return {
        phone_code: this.phoneCode,
        phone_number: this.phoneNumber,
      };
    },

    handleResponse(response) {
      switch (this.getResponceStatusCode(response)) {
        // Номер телефона подтвержден, нужно восстановить пароль
        case responseCodes.RESPONSE_SECURITY_CODE_WAS_SENT:
          this.$router.push({ name: 'enter-sms-code' });
          break;

        default:
          this.setResponseError('Ошибка генерации токена');
      }
    },
  },
};
</script>
